import * as m from 'react';module.exports = { ...m };